import React from "react";
import Slider from "../../components/Slider";
import { useSelector, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { mainPlayerToggle } from "../../redux/actions/styles";
import GradientSecondary from "../../components/gradient/GradientSecondary";
import TooltipPrimary from "../../components/tooltips/TooltipPrimary";
import SyncRoundedIcon from "@mui/icons-material/SyncRounded";
import ShuffleRoundedIcon from "@mui/icons-material/ShuffleRounded";
import SkipPreviousRoundedIcon from "@mui/icons-material/SkipPreviousRounded";
import SkipNextRoundedIcon from "@mui/icons-material/SkipNextRounded";
import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";
import PauseRoundedIcon from "@mui/icons-material/PauseRounded";
import HourglassBottomRoundedIcon from "@mui/icons-material/HourglassBottomRounded";
import ExpandLessRoundedIcon from "@mui/icons-material/ExpandLessRounded";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import { useLocation } from "react-router-dom";
import { playNewSong, setcurrentSongIndex, setplay } from "../../redux/actions/player";

const MainPlayer = (props) => {
  const { playSong, pauseSong, onChangeRange, onClickPrev, onClickNext } = props;

  const { pathname } = useLocation();

  const dispatch = useDispatch();
  const AC = bindActionCreators({ mainPlayerToggle }, dispatch);
  const {
    currentSong: { name, artist, img },
    maxRange,
    range,
    play,
    loaded,
    onChangeLoaded,
    currentSongIndex,
    currentSongList,
  } = useSelector((state) => state.player);
  const { mainPlayerOpen } = useSelector((state) => state.styles);

  function minCalc(value) {
    const min = Math.floor(value / 60);
    let sec = value % 60;
    sec = sec <= 9 ? `0${sec}` : sec;
    return `${isNaN(min) ? "00" : min}:${isNaN(sec) ? "00" : sec}`;
  }

  // function onClickNext() {
  //   const song =
  //     currentSongIndex === currentSongList.length - 1 ? currentSongList[0] : currentSongList[currentSongIndex + 1];
  //   dispatch(playNewSong(song));
  //   dispatch(setplay(true));
  //   currentSongIndex === currentSongList.length - 1
  //     ? dispatch(setcurrentSongIndex(0))
  //     : dispatch(setcurrentSongIndex(currentSongIndex + 1));
  // }
  // function onClickPrev() {
  //   const song =
  //     currentSongIndex === 0 ? currentSongList[currentSongList.length - 1] : currentSongList[currentSongIndex - 1];
  //   dispatch(playNewSong(song));
  //   dispatch(setplay(true));
  //   currentSongIndex === 0
  //     ? dispatch(setcurrentSongIndex(currentSongList.length - 1))
  //     : dispatch(setcurrentSongIndex(currentSongIndex - 1));
  // }

  return (
    <div
      className={`main-player ${!mainPlayerOpen ? "player-slide-down" : ""} ${
        pathname === "/snap" ? "main-player-hide" : ""
      }`}
    >
      <GradientSecondary />
      <div className="header">
        <div className="toggle-btn" onClick={() => AC.mainPlayerToggle(!mainPlayerOpen)}>
          {mainPlayerOpen ? <ExpandMoreRoundedIcon /> : <ExpandLessRoundedIcon />}
          <p>Player</p>
        </div>
      </div>
      <div className="player">
        <div className="img">
          <img src={img} alt="black pink" />
        </div>

        <div className="info">
          <h1>{name}</h1>
          <h3>{artist}</h3>
          <p>Album</p>
        </div>
        <div className="player-actions">
          <div className="range">
            <div className="timer">
              <p>{minCalc(range)}</p>
              <p>{minCalc(maxRange)}</p>
            </div>
            <Slider min={0} max={maxRange} value={range} onChange={onChangeRange} />
          </div>

          <div className="buttons">
            <TooltipPrimary className="icon" text="Sync" align="left">
              <SyncRoundedIcon />
            </TooltipPrimary>
            <TooltipPrimary className="icon" text="Back" align="top" onClick={onClickPrev}>
              <SkipPreviousRoundedIcon />
            </TooltipPrimary>

            {!loaded || !onChangeLoaded ? (
              <div className="icon spinner">
                <HourglassBottomRoundedIcon />
              </div>
            ) : play ? (
              <TooltipPrimary className="icon pause-btn" text="Pause" align="top" onClick={pauseSong}>
                <PauseRoundedIcon />
              </TooltipPrimary>
            ) : (
              <TooltipPrimary className="icon play-btn" text="Play" align="top" onClick={playSong}>
                <PlayArrowRoundedIcon />
              </TooltipPrimary>
            )}

            <TooltipPrimary className="icon" text="Forward" align="top" onClick={onClickNext}>
              <SkipNextRoundedIcon />
            </TooltipPrimary>
            <TooltipPrimary className="icon" text="Shuffle" align="right">
              <ShuffleRoundedIcon />
            </TooltipPrimary>
          </div>
        </div>
        {/* <div className="actions">hi</div> */}
      </div>
    </div>
  );
};

export default MainPlayer;
